export default __webpack_public_path__ + "static/2-982ad95fc0acebc42c24a4b1efa22bab.png";